<template>
    <div
        class="HeaderSearchResults"
    >
        <div
            class="HeaderSearchResults__main"
        >
            <ais-hits>
                <ul
                    slot-scope="{ items }"
                >
                    <li
                        v-for="item in items"
                        :key="item.objectID"
                    >
                        <a
                            :href="item.uri"
                        >
                            <h3 class="h6 mb-min">
                                <ais-highlight
                                    attribute="title"
                                    :hit="item"
                                />
                            </h3>

                            <div v-html="summary(item)" />
                        </a>
                    </li>
                </ul>
            </ais-hits>

            <div
                class="flex-center-b pt-spacer"
            >
                <ais-stats>
                    <div
                        class="smaller text--grey-dark"
                        slot-scope="{ nbHits }"
                    >
                        <strong>{{ nbHits }}</strong>
                        <span> results found </span>
                    </div>
                </ais-stats>

                <BaseButton
                    modifier="small"
                    :href="searchUrl"
                >
                    View all
                </BaseButton>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeaderSearchResults',
    props: {
        searchUrl: {
            type: String,
            default: ''
        }
    },

    methods: {
        summary(item) {
            const str = item.productCustomDescription || item.productDescription || item.summary
            return str ?  `${str.split(' ').splice(0, 8).join(' ')} ...` : null
        }
    }
}
</script>

<style lang="scss" scoped>
    .HeaderSearchResults {
        position: absolute;
        top: 90px;
        right: 30px;
        transition: top ease-out 0.25s;
        z-index: 4;
        height: calc(100vh - 150px);

        > .container {
            display: flex;
            justify-content: flex-end;
            padding-left: getSpacing(spacer);
            padding-right: getSpacing(spacer);
        }

        .is-fixed & {
            top: 92px;
        }

        .is-fixed .HeaderSearch--hidden-notification & {
            top: 67px;
        }

        .HeaderSearch--hidden-notification & {
            height: calc(100vh - 90px);
        }
    }

    .HeaderSearchResults__main {
        background: getColor('white');
        color: $base-font-color;
        padding: getSpacing(medium);
        padding-top: getSpacing(small);
        width: 520px;
        box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.2);
        border-radius: 1px;
        max-height: 100%;
        overflow: auto;
        padding-bottom: 100px;
    }

    li {
        padding: getSpacing(base)  0;
        border-bottom: 1px solid $border-color;
        opacity: 1;
        transition: opacity ease-out 0.25s;

        h3 {
            font-size: 1rem;
        }

        ::v-deep p {
            font-size: 0.8rem;
            line-height: 1.25;
        }

        &:hover {
            opacity: 0.75;
        }
    }

    .BaseButton {
        width: 100px;
        padding-right: 0;
        padding-left: 0;
    }

    ::v-deep .ais-Highlight-highlighted + .ais-Highlight-highlighted {
        margin-left: 4px;
    }
</style>
